import { IOptionItem } from './IOptionItem';
export class Timer implements IOptionItem {
    public static MAX_TIME: number = 840000;
    public static MIN_TIME: number = 360000;
    constructor(
        public id?: number,
        public time?: number,
        public image: string = 'assets/images/timer.png',
        public name?: string,
        public description?: string,

    ) {

    }

    public static fromData(data: any) {
        if (!data) return;
        let o = new Timer(
            data.id,
            data.time,
            data.image,
            data.name,
            data.description
        )
        return o;
    }
    public get value() {
        var minutes = Math.floor(this.time / 60000);
        let minutesStr = (minutes < 10) ? '0' + minutes : minutes + "";
        var seconds = (this.time % 60000) / 1000;
        var secondsStr = seconds < 10 ? "0" + seconds.toFixed(0) : seconds.toFixed(0);
        return minutesStr + ":" + secondsStr;
    }
    public get icon() { return "fa-clock-o" }
}